import {NatGetHolidayMaster} from './NatGetHolidayMaster'
import Http from '../../../../network/Http'

export default class NatHoliDayMasterRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // 祝日マスタ一覧取得
    async getHolidayMaster(startDate: string, endDate: string): Promise<NatGetHolidayMaster> {
        return await this.http.get(`/api/common/holidayMaster?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`);
    }
}
